import React, { useState } from 'react';
import OverlayTextArea from '../components/OverlayTextArea';
import SerpPreview from '../components/SerpPreview';
import SeoText from '../components/SeoText';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import CharacterCount from '../components/CharacterCount';
import { Button } from '../components/ui/button';
import InfoIcon from '../components/InfoIcon';

function FeaturedSnippet() {
  const [snippet, setSnippet] = useState('');

  const getStatusColor = (length) => {
    if (length < 200) return 'text-negative';
    if (length <= 300) return 'text-positive';
    return 'text-negative';
  };

  const getStatusText = (length) => {
    if (length < 200) return 'Below optimal range';
    if (length <= 300) return 'Optimal length';
    return 'Above recommended length';
  };

  const handleClear = () => {
    setSnippet('');
  };

  const handleCopy = () => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(snippet);
    }
  };

  return (
    <>
      {/* Tools Section */}
      <div className="max-w-6xl mx-auto px-6 pb-12">
        <div className="flex gap-6">
          {/* Left column */}
          <Card className="flex-1">
            <CardHeader>
              <div className="flex items-center gap-2">
                <CardTitle className="leading-none">Featured Snippet Editor</CardTitle>
                <InfoIcon 
                  text="Click here for tips on how to optimize your featured snippet" 
                  href="#featured-snippet-guide" 
                  alignWithTitle={true}
                />
              </div>
            </CardHeader>
            <CardContent>
              <div className="space-y-4">
                <div className="flex items-center justify-between">
                  <div className="space-y-1">
                    <h4 className="text-sm font-medium text-text-primary">Content</h4>
                    <p className="text-sm text-text-secondary">Recommended: 200-300 characters</p>
                  </div>
                  <div className="text-right">
                    <CharacterCount count={snippet.length} limit={300} type="featured-snippet" showInfinite={false} />
                    <p className={`mt-1 text-sm ${getStatusColor(snippet.length)}`}>
                      {getStatusText(snippet.length)}
                    </p>
                  </div>
                </div>

                <OverlayTextArea
                  value={snippet}
                  onChange={setSnippet}
                  rows={6}
                  limit={300}
                  limitType="char"
                  className="mb-2"
                />
                <div className="flex justify-end gap-2">
                  <Button variant="secondary" onClick={handleClear}>
                    Clear
                  </Button>
                  <Button onClick={handleCopy}>
                    Copy
                  </Button>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Right column */}
          <Card className="flex-1">
            <CardHeader>
              <CardTitle>SERP Preview</CardTitle>
            </CardHeader>
            <CardContent>
              <SerpPreview
                title="Featured Snippet"
                metaDesc="Preview how your content might appear in Google's featured snippet"
                snippet={snippet}
                isDefinitionBox={true}
              />
            </CardContent>
          </Card>
        </div>
      </div>

      {/* Documentation Section - White Background */}
      <div className="bg-white">
        <SeoText />
      </div>
    </>
  );
}

export default FeaturedSnippet;